import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Place } from 'src/app/models/place.model';
import { ResponseObject } from 'src/app/models/response-object.model';

import { PlaceService } from 'src/app/services/place.service';

@Component({
  selector: 'app-place-list',
  templateUrl: './place-list.component.html',
  styleUrls: ['./place-list.component.scss']
})
export class PlaceListComponent {

  showModalCreate = false;
  placeName: string = null;
  loadingCreate = false;

  places: Place[] = [];
  placeSelected: Place = null;
  placeSelectedId: number = null;

  pagination = {
    total: [],
    filter: [],
    pageSize: 10,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };

  filterWord: string = null;

  editPlace: { [key: number]: boolean } = {};
  loading = false;

  updatingActive: { [key: string]: boolean } = {};
  loadingUpdate: { [key: string]: boolean } = {};

  constructor(
    private placeService: PlaceService,
    private toastService: ToastrService
  ) { }

  ngOnInit(): void {
    this.getPlaces();
  }


  getPlaces() {
    this.loading = true;

    this.placeService.getPlaces().subscribe({
      next: (response: ResponseObject) => {
        this.places = response.data || [];
        this.pagination.total = this.places;
        this.pagination.filter = this.places;

        this.resetPagination();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener ubicaciones.", "Error");
        this.loading = false;
      }
    });
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  setPlaceSelected(place: Place) {
    this.placeSelected = place;
    this.placeSelectedId = place?.id;
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWord = value;
    this.searching();
  }

  searching() {
    const filter = (this.filterWord || '').toLowerCase().trim();

    this.pagination.total = this.places.filter((p) => {
      if (!filter) return true;
      return (p.name || '').toLowerCase().includes(filter);
    });

    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  editingName(place: Place) {
    if (this.editPlace[place.id]) {
      this.editPlace[place.id] = false;
      return;
    }
    this.editPlace[place.id] = true;
  }

  updatePlace(place: Place) {
    if (!place?.id) return;

    const name = (place.name || '').trim();
    if (!name) {
      this.toastService.warning("El nombre no puede ir vacío.", "Aviso");
      return;
    }

    this.loadingUpdate[place.id] = true;

    // Usando tu controller: PUT /erp/places con {id, name}
    this.placeService.updatePlace(place.id, { name }).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("ubicación actualizado correctamente.", "Éxito");
        this.editPlace[place.id] = false;
        this.loadingUpdate[place.id] = false;
        this.getPlaces();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se actualizó el nombre de la ubicación.", "Error");
        this.editPlace[place.id] = false;
        this.loadingUpdate[place.id] = false;
      }
    });
  }

  setActivePlace(place: Place) {
    if (!place) return;

    if (place.active) {
      this.disablePlace(place);
    } else {
      this.enablePlace(place);
    }
  }

  disablePlace(place: Place) {
    this.updatingActive[place.id] = true;

    this.placeService.deletePlace(place.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Ubicación desactivado correctamente.", "Éxito");
        place.active = false;
        this.updatingActive[place.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pudo desactivar la ubicación.", "Error");
        this.updatingActive[place.id] = false;
      }
    });
  }

  enablePlace(place: Place) {
    this.updatingActive[place.id] = true;

    this.placeService.updatePlace(place.id, { active: true }).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Ubicación activado correctamente.", "Éxito");
        place.active = true;
        this.updatingActive[place.id] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pudo activar la ubicación.", "Error");
        this.updatingActive[place.id] = false;
      }
    });
  }

  openModal() {
    this.showModalCreate = true;
    this.placeName = null;
  }

  closeModal(event: any) {
    this.showModalCreate = false;
    this.placeName = null;
  }

  addPlace() {
    const name = (this.placeName || '').trim();
    if (!name) return;

    this.loadingCreate = true;

    this.placeService.createPlace({ name }).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Ubicación agregada.", "Éxito");
        this.loadingCreate = false;
        this.closeModal(true);
        this.getPlaces();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al agregar la ubicación.", "Error");
        this.loadingCreate = false;
      }
    });
  }
}
